export default __webpack_public_path__ + "static/media/DragonballFighterZ.0ddd3116.jpg";